import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import moment from 'moment';
import 'moment/locale/es';
import {formatCurrency} from '../../utils/validations'
import './index.css';

export default function CreatePFD(props) {
  let { pdf, reimpresion, otrasFact } = props;
  const [ticketPDF, setTicketPDF] =  useState(pdf);
  const {syncs} =  useSelector((state)=>{ return state })
  const {qrCliente, qrClienteMensaje, logo} = syncs.configuracion;
  let { cliente, facturas_abono, forma_Pago, cliente_nombre,
    importe_total, moneda_pago, num_ticket, guardado_sap,
    fecha_abono, vendedor, enFirebase, id_ticket, tipo, cancelado,
    comentarios, refBanco, tipo_cambio, referencia, vendedor_nombre,
    rechazado, folioRechazo, comentariosRechazo, fechaRechazo } = ticketPDF;
  let fecha = moment(fecha_abono).format('LLL') ;
  cliente_nombre = cliente_nombre.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});

  return (
    <div key={"CreatePDF" + num_ticket}>
      <div className="body" id="pdfdiv">
        <div className="page-wrap">
          <p className="header">Recibo de cobranza</p>
          <div className="cabeza">
            <div className="space-between">
              <div>
                  <br/>
                  <span className="address">Agri Star México S de RL de CV </span>
                  <br/>
                  <span className="address">Av. Mariano Otero #2347, 3er piso  </span>
                  <br/>
                  <span className="address">Col. Verde Valle,C.P. 44550, Gdl, Jal.</span>
              </div>
              <div className="logo">
                  <img className="image" src={"data:image/png;base64," + logo} alt="logo" style={{width: 150, maxHeight: 80}}/>
              </div>
            </div>
          </div>
          <br/>
          <div className="containera">
            <div className="space-between">
              <div  className="container0">
                <div className="space-between">
                  <div className="infoColumna">Vendedor</div>
                  <div className="detalleColumnaL">{vendedor}</div>
                </div>
                <div className="space-between">
                  <div className="infoColumna"></div>
                  <div className="detalleColumnaL">{vendedor_nombre}</div>
                </div>
                <div className="space-between">
                <div className="infoColumna"><p/></div>
                <div className="detalleColumnaL"></div>
                </div>
                <div className="space-between">
                  <div className="infoColumna">Cliente</div>
                  <div className="detalleColumnaL">{cliente}</div>
                </div>
                <div className="space-between">
                  <div className="infoColumna"></div>
                  <div className="detalleColumnaL">{cliente_nombre}</div>
                </div>
              </div>
              <div  className="container1">
                <div className="space-between">
                  <div></div>
                </div>
              </div>
              <div  className="container2">
                  <div className="space-between">
                    <div className="infoColumna">Ticket</div>
                    <div  className="detalleColumnaR">{num_ticket}</div>
                  </div>
                  <div className="space-between">
                  <div className="infoColumna">Fecha y hora</div>
                    <div className="detalleColumnaR">{fecha}</div>
                  </div>
                <div className="space-between">
                  <div className="infoColumna">Importe</div>
                    <div  className="detalleColumnaR">{formatCurrency(importe_total)}</div>
                  </div>
                <div className="space-between">
                  <div className="infoColumna">Moneda</div>
                    <div className="detalleColumnaR">{moneda_pago}</div>
                  </div>
                  <div className="space-between">
                    <div className="infoColumna">Tipo de cambio</div>
                    <div  className="detalleColumnaR">{formatCurrency(tipo_cambio)}</div>
                  </div>
                  <div className="space-between">
                    <div className="infoColumna">Forma de pago</div>
                    <div className="detalleColumnaR">{forma_Pago}</div>
                  </div>
                  {referencia?
                    <div className="space-between">
                      <div className="infoColumna">Referencia:</div>
                      <div className="detalleColumnaR">{referencia}</div>
                    </div> 
                  :""}
                  <div className="space-between">
                    <div className="infoColumna">Referencia de Pago</div>
                    <div className="detalleColumnaR">{refBanco}</div>
                  </div>
                </div>
              </div>
              <p/>
            <table className="items">
              <thead>
                <tr>
                    <th>#</th>
                    <th>Factura</th>
                    <th>Fecha factura</th>
                    <th>Fecha vencimiento</th>
                    <th>Total</th>
                    <th>Abono</th>
                    <th>Saldo</th>
                    <th>Restante</th>
                </tr>
              </thead>
              <tbody>
              {
                facturas_abono.map((element,i) => {
                  return(
                  <tr className="item-row" key={element.BELNR} >
                    <td className="item-name">{i +1}</td>
                    <td className="description">{element.BELNR}</td>
                    <td className="description">{element.BUDAT}</td>
                    <td className="total-line">{element.BLDAT?element.BLDAT:element.FKDAT}</td>
                    <td className="total-line">{formatCurrency(element.DMBTR)}</td>
                    <td className="total-line">{formatCurrency(element.tmp_saldo)}</td>
                    <td className="total-line">{formatCurrency(element.abono)}</td>
                    <td className="total-line">{element.DMBTR !== "0"? formatCurrency(element.tmp_saldo - element.abono): "$0.00"}</td>
                  </tr>)})
              }
              </tbody>
            </table>
            {otrasFact.length >0?
              <>
              <br/>
              <h4 style={{textAlign:"center", fontWeight:"bold"}}>Otras facturas pendientes de pago</h4>
              <table className="items">
                <tbody>
                <tr>
                  <th>#</th>
                  <th>Factura</th>
                  <th>Fecha vencimiento</th>
                  <th>Total</th>
                  <th>Saldo</th>
                </tr>
                {
                  otrasFact.map((element,i) => {
                    return(
                    <tr key={element.BELNR} className="item-row">
                      <td className="item-name">{i +1}</td>
                      <td className="description">{element.BELNR}</td>
                      <td className="description">{element.BLDAT}</td>
                      <td className="total-line">{formatCurrency(element.DMBTR)}</td>
                      <td className="total-line">{formatCurrency(element.DMBTR)}</td>
                    </tr>)})
                }
                </tbody>
              </table>
              </>: null
            }
          </div>
        </div>
        <div className="terms">
          {reimpresion?
            <h6>REIMPRESION</h6>
            :null
          }
          <h5>Notas Importantes</h5>
          <span style={{fontWeight: "bold"}}>** ESTO NO ES UN COMPLEMENTO DE PAGO **</span><br/>
          <span>** Los pagos notificados serán reconocidos una vez validados por el área de tesorería. **</span ><br/>
          <span>** Este archivo es sólo de carácter informativo, no tiene validez oficial como comprobante legal o fiscal. ** </span ><br/><span>** {qrClienteMensaje} ** </span><br/><img id="qr" src={`data:image/png;base64,${qrCliente}`} alt="qr" style={{width:150}}/><br/>{ticketPDF.comentarios && ticketPDF.comentarios !== ''? <><span style={{fontSize:"115%", fontWeight: "bold"}}> {ticketPDF.comentarios} </span></>: ''}
        </div>    
      </div>
    </div>
  );
}